import React from 'react';
import { getImageUrl } from '../../utils/imageUtils';

const ListingImageWithStoreLogo = ({ 
  listingImage, 
  storeLogo, 
  profilePicture, 
  storeName,
  size = 'md',
  showBadge = false,
  badgeContent = null,
  className = ''
}) => {
  const sizes = {
    sm: { 
      container: 'w-12 h-12', 
      logo: 'w-6 h-6', 
      logoPosition: '-bottom-1.5 -right-1.5',
      border: 'border-2'
    },
    md: { 
      container: 'w-16 h-16', 
      logo: 'w-7 h-7', 
      logoPosition: '-bottom-2 -right-2',
      border: 'border-2'
    },
    lg: { 
      container: 'w-20 h-20', 
      logo: 'w-9 h-9', 
      logoPosition: '-bottom-2.5 -right-2.5',
      border: 'border-3'
    },
    xl: { 
      container: 'w-24 h-24', 
      logo: 'w-10 h-10', 
      logoPosition: '-bottom-3 -right-3',
      border: 'border-3'
    }
  };
  
  const { container, logo, logoPosition, border } = sizes[size];
  const logoUrl = storeLogo || profilePicture;
  const logoInitial = (storeName || 'S').charAt(0).toUpperCase();
  const logoBgColor = storeLogo ? 'bg-blue-500' : 'bg-[#ff660e]';

  return (
    <div className={`relative inline-block ${className}`}>
      {/* Listing Image Container */}
      <div className={`${container} rounded-xl overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center shadow-md hover:shadow-lg transition-shadow duration-200`}>
        {listingImage ? (
          <img
            src={getImageUrl(listingImage)}
            alt="Listing"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
            onError={(e) => {
              e.target.style.display = 'none';
              const fallback = e.target.parentNode.querySelector('.listing-fallback');
              if (fallback) {
                fallback.style.display = 'flex';
              }
            }}
          />
        ) : (
          <div className="listing-fallback w-full h-full flex items-center justify-center">
            <span className="text-gray-400 text-2xl">📦</span>
          </div>
        )}
      </div>

      {/* Store/Profile Logo Overlay */}
      <div className={`absolute ${logoPosition}`}>
        <div className={`${logo} rounded-full ${border} border-white ${logoBgColor} flex items-center justify-center overflow-hidden shadow-lg`}>
          {logoUrl ? (
            <img
              src={getImageUrl(logoUrl)}
              alt={storeLogo ? 'Store' : 'Profile'}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentNode.innerHTML = `
                  <span class="text-white font-bold ${size === 'xl' ? 'text-sm' : 'text-xs'}">${logoInitial}</span>
                `;
              }}
            />
          ) : (
            <span className={`text-white font-bold ${size === 'xl' ? 'text-sm' : 'text-xs'}`}>
              {logoInitial}
            </span>
          )}
        </div>
      </div>

      {/* Optional Badge (for unread count, status, etc.) */}
      {showBadge && badgeContent && (
        <div className="absolute -top-1 -right-1 z-10">
          {badgeContent}
        </div>
      )}
    </div>
  );
};

export default ListingImageWithStoreLogo;